import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=5f020525&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=5f020525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f020525",
  null
  
)

export default component.exports